import { render, staticRenderFns } from "./PageBottomCarouselApp.vue?vue&type=template&id=9100d0a4&scoped=true"
import script from "./PageBottomCarouselApp.vue?vue&type=script&lang=ts"
export * from "./PageBottomCarouselApp.vue?vue&type=script&lang=ts"
import style0 from "./PageBottomCarouselApp.vue?vue&type=style&index=0&id=9100d0a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9100d0a4",
  null
  
)

export default component.exports